import type { RouteConfig } from 'vue-router';
import { LicenseFeature, Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/admin',
    name: 'ctx-admin-functions',
    component: () => import(/* webpackChunkName: "ctx-admin-functions" */ './AdminFunctionsView.vue'),
    meta: {
        role: Role.COMPANY_ADMIN,
        license: [LicenseFeature.PLANDATA_IMPORT],
        authenticated: true,
        settingsTabs: true,
        settingsTabsGroup: 'company-admin',
        portfolioTabs: false,
        navbar: true,
        footer: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
